import axios from 'axios'
import Vue from 'vue'
import router from '@src/routers/index.js'
import store from '@src/stores/index.js'

const buildtype = process.env.NODE_ENV
console.log("process.env.NODE_ENV=======>",process.env.NODE_ENV)
var url=''
switch (buildtype) {
    case 'production': // 实际生产环境
        url="https://followupcenter.huidr.com/api";
        break;
    case 'development': //开发
        // url="http://192.168.1.117:8466"
        url="https://callcenter.test.huidr.com/"
        break;
    case 'test': //测试
        url="/api"
        break;
    case 'LOCAL':
        url="/";
        // url='https://192.168.1.106:8466';
        // url="https://callcenter.test.huidr.com"
        break;

}
const service = axios.create({
    // baseURL: '/api'
    baseURL: url,
    headers:{
        'Content-Encoding':'gzip'  // 设置请求内容可压缩
    }
})

// service.interceptors.request.use(function (config) {
//     if(buildtype ==="dev"){
//         var s=new RestVcodeGetVcode()
//         if(config.url.substr(config.baseURL.length) == s.url){
//             var b=new RestVcodeGetVcodeTest();
//             config.url=config.baseURL+b.url
//         }
//     }
//     return config;
// }, function (error) {
//     return Promise.reject(error);
// });
service.interceptors.response.use(
    response => {  //成功请求到数据
        // 鉴权失败
        if (response.data&&response.data.status === -3) {
            let $confirm = Vue.prototype.$confirm;
            if($confirm){
                $confirm('登录过期，请重新登录' , '提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type:"warning"
                }).then(()=>{
                    console.log('logout5')
                    store.commit('logout');
                    router.replace({
                        path:'/login'
                    })
                }).catch(() => {});
            }else{
                //   鉴权失败，重新登录
                console.log('logout6')
                store.commit('logout');
                router.replace({
                    path:'/login'
                })
            }
            return response;
        }else{
            return response;
        }
    },
    error => {  //响应错误处理
        if(error.data&&error.data.status === -3){
            console.log('logout7')
            store.commit('logout');
            router.replace({
                path:'/login'
            })
        }
        return Promise.reject(error)
    }
);
export default service
